import { Outlet } from "react-router-dom";

export default function JudgeLayout() {
  return (
    <div
      style={{
        height: "100vh",
        background: "#111",
        color: "white",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: 20
      }}
    >
      <Outlet />
    </div>
  );
}
